import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'overview',
    label: 'Overview Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
